import {useState} from 'react';
import {connect} from 'react-redux';
import {Grid} from 'semantic-ui-react';
import MobileForm from './mobile-form';
import SMSKeyForm from '../shared/sms-key-form';
import ErrorMessage from '../shared/error-message';
import Fetcher from '../shared/fetches/fetcher';
import {fetchActiveStudentTypes} from '../../redux/actions/student-type';
import RegisterForm from './register-form';
import {checkSmsKeyRequest, createTempUser, sendSmsKeyRequest} from '../../redux/actions/temp-user';

function RegisterContent(props) {
  const [step, setStep] = useState(0);
  const [mobile, setMobile] = useState(null);
  const [authKey, setAuthKey] = useState(null);
  const [error, setError] = useState(null);

  if (error) return (<ErrorMessage message={error}/>);

  if (step === MOBILE) {
    return (
      <Grid centered verticalAlign='middle' size='big'>
        <Grid.Column mobile={16} tablet={12} computer={10}>
          <MobileForm
            onSubmit={async function (mobile) {
              await props.createTempUser(mobile);
              setMobile(mobile);
              setStep(SMS_KEY);
            }}
          />
        </Grid.Column>
      </Grid>
    );
  }

  if (step === SMS_KEY) {
    return (
      <Grid centered verticalAlign='middle' size='big'>
        <Grid.Column mobile={16} tablet={12} computer={10}>
          <SMSKeyForm
            back
            mobile={mobile}
            onSubmit={async function (smsKey) {
              const {payload: {authKey}} = await props.checkSmsKeyRequest(mobile, smsKey);
              setAuthKey(authKey);
              setStep(REGISTER);
            }}
            onResend={async function () {
              await props.sendSmsKeyRequest(mobile);
            }}
            onBack={function () {
              setStep(MOBILE);
            }}
            onError={setError}
          />
        </Grid.Column>
      </Grid>
    );
  }

  if (step === REGISTER) {
    return (
      <Fetcher
        action={fetchActiveStudentTypes}
        stateSelector={state => state.studentTypes}
      >
        {studentTypes => (<RegisterForm mobile={mobile} authKey={authKey} studentTypes={studentTypes}/>)}
      </Fetcher>
    );
  }

  return null;
}

const [MOBILE, SMS_KEY, REGISTER] = [0, 1, 2];

export default connect(null, {createTempUser, sendSmsKeyRequest, checkSmsKeyRequest})(RegisterContent);
